import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { getColor, getSize, MathEnabledTextComponent } from '@lib/common';
import styled from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledHeadingWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 32px 24px;\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);\n  background: ", ";\n  border-radius: ", ";\n"])), getColor('fillBgWhite'), getSize('radiusSm'));
var StyledHeading = styled.h2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: ", ";\n  color: ", ";\n"])), getSize('typo20'), getColor('contentHeading'));
var StyledHeadingContent = styled(MathEnabledTextComponent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  color: #000000;\n"])));
export var HeadingPreviewComponent = function HeadingPreviewComponent(_ref) {
  var heading = _ref.heading;
  return /*#__PURE__*/_jsxs(StyledHeadingWrapper, {
    children: [/*#__PURE__*/_jsx(StyledHeading, {
      children: heading.title
    }), /*#__PURE__*/_jsx(StyledHeadingContent, {
      value: heading.description
    })]
  });
};